import NewTable, { TableBodyData, TableHeaderColumn } from "components/NewTable";
import PageDefault from "components/PageDefault";
import { Button, Col, Row } from "react-bootstrap";
import { Link, useHistory } from "react-router-dom";
import companyService from "services/company.service";
import { formatDocument } from "utils/format";
import Can from "components/Can";
import { useTranslation } from "react-i18next";
import Icon from "components/Icon";


export default function Company() {
  const history = useHistory();
  const { t } = useTranslation()

  return <PageDefault title={t('company:page_title')}>
    <PageDefault.Title>{t('company:page_title')}</PageDefault.Title>
    <PageDefault.Content>
      <Row className="mt-3 mb-3">
        <Col>
          <Link to="/company/create">
            <Button>{t('company:add_btn')}</Button>
          </Link>
        </Col>
      </Row>
      <NewTable exportSelectColumns>
        <TableHeaderColumn dataField="id">{t('company:table_header:id')}</TableHeaderColumn>
        <TableHeaderColumn dataField="name">{t('company:table_header:name')}</TableHeaderColumn>
        <TableHeaderColumn dataField="alias">{t('company:table_header:alias')}</TableHeaderColumn>
        <TableHeaderColumn dataField="document" mask={(v:any)=>{
          return v?formatDocument(v):"";
        }}>{t('company:table_header:document')}</TableHeaderColumn>
        <TableHeaderColumn 
        isAction
        dataField="id|" 
        mask={(v:any[])=>{
          const [id] = v;
          return (
            <>
              <Can permission="company.update">
                <Button size="sm" style={{margin:"0px 1px"}} onClick={()=>{history.push(`company/edit/${id}`);}}><Icon name="edit"/></Button>
              </Can>
              <Can permission="company.view">
                <Button size="sm" style={{margin:"0px 1px"}} onClick={()=>{history.push(`company/show/${id}`);}}><Icon name="eye"/></Button>
              </Can>
              {/* <Can permission="company.access">
                <Button size="sm" style={{margin:"0px 1px", fontWeight:"bold"}} onClick={()=>{
                  company.set({id,name,alias,cleanable:true, connected:true});
                  history.push(`/`);
                }}>Acessar</Button>
              </Can> */}
            </>
          );
        }}>{t('company:table_header:action')}</TableHeaderColumn>
        <TableBodyData request={companyService} filterDefaut={{
          order_column: '!id'
        }}/>
      </NewTable>
    </PageDefault.Content>
  </PageDefault>;
}